import init, {
  CryptoClient,
  decryptFileChunk,
  encryptFileChunk,
  FileHasher,
  linkCode,
  newFileKey,
  safetyNumber,
  verifyDeviceList,
} from './pkg/swchat_crypto_wasm.js';

export * from './pkg/swchat_crypto_wasm.js';

let ready;

/** Khởi tạo WASM một lần. Trình duyệt: không cần tham số (hoặc URL do bundler cấp). */
export function initCrypto(input) {
  ready ??= init(input === undefined ? undefined : { module_or_path: input });
  return ready;
}

/** Cài đặt `CryptoBackend` của @swchat/client-sdk. Gọi sau `initCrypto()`. */
export const backend = {
  createClient: (userId, deviceId) => new CryptoClient(userId, deviceId),
  importClient: (state) => CryptoClient.importState(state),
  verifyDeviceList: (payload, signature, pinned) => verifyDeviceList(payload, signature, pinned ?? undefined),
  safetyNumber,
  linkCode,
  newFileKey,
  encryptFileChunk,
  decryptFileChunk,
  createFileHasher: () => new FileHasher(),
};
